<!-- <div class="footer">
    <button type="button" on:click={() => {location.href = "#"}}>스캔</button>
    <button type="button" on:click={() => {location.href = "#/search"}}>조회</button>
</div> -->
<div class="btm-btn">
	<div class="btm-btn-in">
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<p on:click={() => {location.href = "#/"}}>스캔</p>
	</div>
	<div class="btm-btn-in">
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<p on:click={() => {location.href = "#/search"}}>조회</p>
	</div>
</div>